import { FindParams } from './find-params';

export interface FindAvailabilityParams extends FindParams {
  date: string;
  zip: string;
  part_of_day: string;
  include_closed: boolean;
}
